import React from "react";
import {
  SimpleForm,
  TextField,
  NumberField,
  ReferenceInput,
  Edit,
  AutocompleteInput,
  SelectInput,
  TabbedShowLayout,
  required,
} from "react-admin";
import {
  LabeledColumn,
  TitledShow,
} from "../../_myBase/components/titledRecord";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import FavoriteLocationsList from "../favorite_locations/FavoriteLocationsList";
import LocationDiscountPlanTab from "./LocationDiscountPlanTab";
import LocationFeatureFlagsTab from "./LocationFeatureFlagsTab";
import LocationMultiDaySessionsTab from "./LocationMultiDaySessionsTab";

export default function LocationShow(props) {
  const id = parseInt(useParams()["id"]);

  return (
    <TitledShow>
      <TabbedShowLayout>
        <TabbedShowLayout.Tab label="Summary">
          <Stack spacing={4} direction="row">
            <LabeledColumn>
              <TextField disabled label="Id" source="id" />
              <TextField source="name" />
              <NumberField source="address1" />
              <NumberField source="lat" />
              <NumberField source="lon" />
            </LabeledColumn>
          </Stack>
          <Edit {...props}>
            <SimpleForm
              transform={(data) => ({
                additionalProperties: {
                  pricingPlan: {
                    id: data.additionalProperties?.pricingPlan?.id,
                  },
                },
                currency: data.currency ?? null,
              })}
            >
              <ReferenceInput
                label="Pricing Plan"
                source="additionalProperties.pricingPlan.id"
                reference="pricing-plans"
                perPage={200}
              >
                <AutocompleteInput
                  optionText="name"
                  optionValue="id"
                  validate={[required()]}
                  filterToQuery={(searchText) => ({
                    name:
                      searchText.charAt(0).toUpperCase() + searchText.slice(1),
                  })}
                />
              </ReferenceInput>
              <SelectInput
                source="currency"
                label="Currency"
                choices={[
                  { id: "usd", name: "USD — US Dollar" },
                  { id: "cad", name: "CAD — Canadian Dollar" },
                ]}
                allowEmpty
                emptyText="Not set (defaults to USD)"
              />
            </SimpleForm>
          </Edit>
        </TabbedShowLayout.Tab>

        <TabbedShowLayout.Tab
          label="Favorite Locations"
          path="favorite-locations"
        >
          <FavoriteLocationsList filter={{ locationId: id }} />
        </TabbedShowLayout.Tab>

        <TabbedShowLayout.Tab label="Discount Plan" path="discount-plan">
          <LocationDiscountPlanTab locationId={id} />
        </TabbedShowLayout.Tab>

        <TabbedShowLayout.Tab label="Feature Flags" path="feature-flags">
          <LocationFeatureFlagsTab locationId={id} />
        </TabbedShowLayout.Tab>

        <TabbedShowLayout.Tab
          label="Multi-Day Sessions"
          path="multi-day-sessions"
        >
          <LocationMultiDaySessionsTab locationId={id} />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </TitledShow>
  );
}
